import React from "react";
import { Helmet } from "react-helmet";
import MBACapstoneSection from "./components/MBACapstoneSection";
import MBACorporateSection from "./components/MBACorporateSection";
import MBACurriculumSection from "./components/MBACurriculumSection";
import MBAExtrasSection from "./components/MBAExtrasSection";
import MBAFinalCTA from "./components/MBAFinalCTA";
import MBAFloatingApplyButton from "./components/MBAFloatingApplyButton";
import MBAGraduationSection from "./components/MBAGraduationSection";
import MBAHeaderSection from "./components/MBAHeaderSection";
import MBAOutcomesSection from "./components/MBAOutcomesSection";
import MBAPartnersSection from "./components/MBAPartnersSection";
import MBAPricingSection from "./components/MBAPricingSection";
import MBAScholarshipSection from "./components/MBAScholarshipSection";
import MBAValueSection from "./components/MBAValueSection";
import SiteFooter from "../../components/layout/SiteFooter";

const MBA = () => {
  return (
    <div>
      <Helmet>
        <title>
          Utiva Global MBA | 5 International University Partnerships
        </title>
        <meta
          name="description"
          content="A practical five-month program for professionals ready to build stronger judgement across leadership, growth, finance, execution, AI and digital transformation—with international learning access through Utiva and five global university partners."
        />
        <meta
          property="og:title"
          content="Utiva Global MBA | 5 International University Partnerships"
        />
        <meta
          property="og:description"
          content="A practical five-month program for professionals ready to build stronger judgement across leadership, growth, finance, execution, AI and digital transformation—with international learning access through Utiva and five global university partners."
        />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
      </Helmet>

      <MBAHeaderSection />
      <MBAValueSection />
      <MBAOutcomesSection />
      <MBAScholarshipSection />
      <MBAPartnersSection />
      <MBAGraduationSection />
      <MBACurriculumSection />
      <MBACapstoneSection />
      <MBACorporateSection />
      <MBAExtrasSection />
      <MBAPricingSection />
      <MBAFinalCTA />
      <SiteFooter />
      <MBAFloatingApplyButton />
    </div>
  );
};

export default MBA;
